import { __, prop } from 'ramda';

const PRISMIC_ICON = {
  Rechercher: 'search',
  Télécharger: 'download',
  'Espace presse': 'newsroom',
  'Informations financières': 'financial',
};

export const toIcon = prop(__, PRISMIC_ICON);
